import React, { FC } from "react";

import { IConsultantProfileSkill } from "@/data/consultant-profiles";
import { ISkill } from "@/data/skills";
import { Flex, FloatedList } from "@/eworkitComponents";

import { SuggestedSkillBadge } from "./SuggestedSkillBadge";

interface ISuggestedSkillsListProps {
  suggestedSkills: ISkill[];
  selectedSkills: IConsultantProfileSkill[];
  onSkillClick: (skill: ISkill) => void;
  onCheckedSkillClick: (skill: ISkill) => void;
}

export const SuggestedSkillsList: FC<ISuggestedSkillsListProps> = ({
  onSkillClick,
  onCheckedSkillClick,
  selectedSkills,
  suggestedSkills,
}) => {
  return (
    <>
      <Flex direction="column" innerMargin="md" justify="space-between">
        <FloatedList>
          {suggestedSkills.map(s => (
            <SuggestedSkillBadge
              key={s.id}
              skill={s}
              isChecked={selectedSkills.find(fs => fs.skill.id === s.id) !== undefined}
              onClick={onSkillClick}
              onCheckedClick={onCheckedSkillClick}
            />
          ))}
        </FloatedList>
      </Flex>
    </>
  );
};
